import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { LoadingState, ErrorState } from "./StateViews";
import { cx } from "../lib/cx";

interface DomainDetailPageProps {
  backHref: string;
  backLabel: string;
  onNavigate: (path: string) => void;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
  hero: ReactNode;
  heroVariant?: "surface" | "photo";
  children: ReactNode;
}

export function DomainDetailPage({
  backHref,
  backLabel,
  onNavigate,
  loading,
  error,
  onRetry,
  hero,
  heroVariant = "surface",
  children,
}: DomainDetailPageProps) {
  return (
    <section className="detail-page">
      <div className={cx("detail-hero", heroVariant === "photo" && "detail-hero--photo")}>
        <button
          type="button"
          className={cx("icon-btn detail-hero__back", heroVariant === "photo" && "icon-btn--overlay")}
          onClick={() => onNavigate(backHref)}
          aria-label={backLabel}
        >
          <Icon name="chevron-right" aria-hidden="true" />
        </button>
        {hero}
      </div>

      {loading && <LoadingState />}
      {!loading && error && <ErrorState message={error} onRetry={onRetry} />}
      {!loading && !error && children}
    </section>
  );
}
